import { render, staticRenderFns } from "./FirstMedcardAdditionPopup.vue?vue&type=template&id=57b44c49"
import script from "./FirstMedcardAdditionPopup.vue?vue&type=script&lang=ts"
export * from "./FirstMedcardAdditionPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseFullscreenDialog: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseFullscreenDialog.vue').default})
